<template>
  <div>
    <div
      class="sb_main-menu"
    >
      <RouterLink
        to="/"
        class="sb_main-menu_logo"
        @click.native="closeOverlayMenu"
      >
        <img
          src="static/img/corbion_logo-new-resize@2x.jpg"
          class="sb_main-menu_logo_img"
        >
      </RouterLink>
      <div class="sb_main-menu_content">
        <div
          class="sb_main-menu_content_inner"
          style="background-image: url('static/img/corbion_menu_main_bg.png')"
        >
          <div class="sb_main-menu_content_left">
            <div
              class="sb_main-menu_content_title"
            >
              Corbion<sup style="font-size: 40%">Ⓡ</sup> <i>Dissociation Tool</i>
            </div>
            <div
              class="sb_main-menu_content_subtitle"
            >
              Dissociation of organic acids in water
            </div>
          </div>
          <div class="sb_main-menu_content_right">
            <div class="sb_main-menu_content_right_inner">
              <button
                class="sb_hamburger sb_hamburger_squeeze u_hide_medium_up"
                :class="{'s_active': showMobileMenu}"
                type="button"
                @click="doToggleOverlayMenu"
              >
                <span class="sb_hamburger-box">
                  <span class="sb_hamburger-inner"></span>
                </span>
              </button>
              <div class="sb_main-menu_menu-secondary">
              </div>
              <div class="sb_main-menu_menu-primary">
                <RouterLink
                  v-for="link in internalLinks"
                  :key="`${link.slug}-1`"
                  :to="`/${link.slug}`"
                >
                  {{ link.text }}
                </RouterLink>
                <a
                  href="mailto:dissociation@corbion.com?subject=Dissociation Calculator"
                  target="blank"
                >Contact</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="sb_main-menu_overlay"
      :class="{'s_active': showMobileMenu }"
    >
      <div
        ref="menuOverlay"
        class="sb_main-menu_overlay_scroll-container"
      >
        <a
          href="mailto:lcm@corbion.com?subject=LCM"
          class="sb_main-menu_overlay_link"
        >Contact
        </a>
      </div>
      <div class="sb_main-menu_overlay_bottom">
        <div class="sb_main-menu_overlay_bottom_inner">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { mapState } from 'vuex';

export default {
  name: 'MainMenu',
  data() {
    return {
      showMobileMenu: false,
      internalLinks: [
        {
          slug: 'faq',
          text: 'FAQ'
        }
      ]
    };
  },
  computed: {
    ...mapState('global', [
      'appTitle'
    ]),
    showLogout() {
      return this.$route.name !== 'home';
    }
  },
  watch: {
    showMobileMenu(newVal) {
      if (newVal) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    }
  },
  created() {},
  methods: {
    closeOverlayMenu() {
      this.showMobileMenu = false;
    },
    doToggleOverlayMenu() {
      window.scrollTo(0, 0);
      this.showMobileMenu = !this.showMobileMenu;
    },
    logout() {
      this.$router.push('/');
      this.showMobileMenu = false;
    }
  }
};
</script>

<style lang="scss">
  .sb_main-menu {
      width: 100%;
      display: flex;
      height: 128px;
      overflow: hidden;

      transition: all .3s ease;

      .sb_button {
        white-space: nowrap;
      }


      &.s_expert-mode {
        height: 88px;
        .sb_main-menu_content_right_inner {
          flex-direction: row-reverse;
          align-items: center;
          justify-content: flex-end;
        }
        .sb_main-menu_logo_img {
           @include media(">=medium-portrait") {
             width: 80px;
           }
        }
      }


      &_logo {
          padding: 1rem 1rem;
          flex: 0 0 auto;
          transition: opacity .3s ease;
          display: flex;
          flex-direction: column;
          justify-content: center;

          &:hover {
            text-decoration: none;
          }

          @include media(">=large") {
            &:hover {
              opacity: .7;
            }
          }

          @include media(">=medium-portrait") {
              padding: 1rem 2.4rem;
          }
          &_img {
              width: 60px;

              @include media(">=medium-portrait") {
                  width: 132px;
              }
          }
      }

      &_content {
          flex: 1 1 auto;
          position: relative;
          background: #444;

          &_inner {
              position: relative;
              width: 100%;
              height: 100%;
              padding: 1rem .6rem 1rem 1rem;
              display: flex;
              @include media(">=medium") {
                padding: 1rem 2rem;
              }
          }

          &_left {
              display: flex;
              flex-direction: column;
              justify-content: center;
          }
          &_right {
              display: flex;
              justify-content: flex-end;
              flex: 1 1 auto;
              margin-left: 1rem;

              &_inner {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
              }
          }

          &_title {
            font-size: 1.1rem;
            font-weight: 400;
            color: #fff;
            @include media(">=medium") {
              font-size: 1.6rem;
            }

            i {
              font-style: italic;
            }
            sup {
              font-size: 60%;
            font-weight: 700;
            }
          }
          &_subtitle {
            font-size: 1.1rem;
            font-weight: 200;
            margin-top: .6rem;
            color: rgba(#fff, 0.4);
            @include media("<large") {
              display: none;
            }
          }
      }

      &_menu-secondary {
          display: flex;
          justify-content: flex-end;
          @include media("<medium") {
              display: none;
          }
      }
      &_menu-primary {
        display: flex;
          justify-content: flex-end;
          @include media("<medium") {
            display: none;
          }
          a {
            text-decoration: none;
            margin-left: 1rem;
            white-space: nowrap;
            color: #fff;
            transition: color .3s ease;
            &:hover {
              color: rgba(#fff, 0.7);
            }
          }
      }
  }
  .sb_main-menu_overlay {
    position: fixed;
    z-index: 3;
    width: 100%;
    height: calc(100vh - 78px);
    background: #444;
    pointer-events: none;
    opacity: 0;
    transition: opacity .3s ease, transform .3s ease;
    transform: translateY(40px);

    @include media(">=medium-portrait") {
        height: calc(100vh - 127px);
    }
    &.s_active  {
      opacity: 1;
      transform: translateY(0);
      pointer-events: inherit;
    }

    @include media(">=medium") {
      display: none;
    }

    &_scroll-container {
      padding: 2rem;
    }
    &_link {
      display: block;
      text-align: center;
      text-decoration: none;
      padding: 1rem;
      font-size: 1.4rem;
      color: $brand-white;
      border-bottom: solid 2px rgba($brand-white, .2);
    }
    &_bottom {
      position: fixed;
      bottom: 0%;
      width: 100%;
      padding: 0 2rem;
      &_inner {
        padding: .6rem 0;
        border-top: solid 2px rgba($brand-white, .2);
      }
    }
  }

  //
  //  SIZING
  //
  #app {
    &[data-route="s_route_calculator"] {
      .sb_main-menu {

        height: 60px;
      }
      .sb_main-menu_logo_img {
        width: 60px;
      }
      .sb_main-menu_content_subtitle {
        display: none;
      }

    }
  }

  //
  // BRAND STYLING
  //
  @include sb_main-menu;

</style>
